import React from "react"
import styled from "styled-components"
import { useTranslation } from "next-i18next"
import { themeGet } from "@styled-system/theme-get"
import Typewriter from "typewriter-effect"

const TypeAnimationCompliance = () => {
  const { t } = useTranslation("joinUs")

  return (
    <div>
      <Typewriter
        options={{
          strings: [
            t("joinUs.desc.1"),
            t("joinUs.desc.2"),
            t("joinUs.desc.3"),
            t("joinUs.desc.4")
          ],
          autoStart: true,
          loop: true
        }}
      />
    </div>
  )
}

const TypeText = () => {
  const { t } = useTranslation("joinUs")

  return (
    <TypeAnimationWrap>
      <TypeAnimationCompliance />
    </TypeAnimationWrap>
  )
}

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ["joinUs"]))
  }
})

const TypeAnimationWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  /* padding: 0 10%; */

  .Typewriter {
    max-width: 1000px;
    text-align: center;
    span {
      color: ${themeGet("colors.primary")};
      /* width: 100%; */
      /* margin-left: auto; */
      /* margin-right: auto; */
      /* min-height: 64px; */
      /* margin-top: 0; */
      font-size: 48px;
      font-weight: 700;
      /* text-align: center; */
      text-shadow:
        0 0 20px ${({ theme }) => theme.colors.primaryLight},
        0 0 60px ${({ theme }) => theme.colors.textShadowLight};
      @media (max-width: 640px) {
        font-size: 32px;
      }
    }
    @media (max-width: 440px) {
      padding: 0 20px;
    }
  }
  @media (max-width: 600px) {
    height: 150px;
  }
`

export default TypeText
